














import { Ref, Watch, Prop, Component, Vue } from 'vue-property-decorator'
import { isEqual } from 'lodash'

@Component
export default class InputTextarea extends Vue {
    @Ref() element!: HTMLTextAreaElement
    @Prop({ type: Boolean, default: false }) readonly notNullable!: boolean
    @Prop({ type: Boolean, default: true }) readonly autoSize!: boolean
    @Prop({ type: Boolean, default: false }) readonly trim!: boolean
    @Prop({ type: Boolean, default: false }) readonly disabled: boolean
    @Prop({ type: Boolean, default: false }) readonly readonly: boolean
    @Prop({ default: null }) readonly rules!: string
    @Prop({ default: null }) readonly placeholder!: string
    @Prop({ default: null }) readonly errorMessage!: string
    @Prop({ default: '2' }) readonly rows!: string
    @Prop() readonly name!: string
    @Prop() readonly label!: string
    @Prop() readonly value!: string
    internalValue: string = null
    focus: boolean = false

    created() {
        this.onExternalChange()
    }

    transformInput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    transformOutput(value: string) {
        if (this.trim && typeof value === 'string') {
            value = value.trim()
        }

        return value
    }

    @Watch('value')
    onExternalChange() {
        this.internalValue = this.transformInput(this.value)

        if (this.internalValue === null) {
            this.internalValue = ''
        }
    }

    @Watch('internalValue')
    onInternalChange() {
        if (this.autoSize) {
            const offset = this.element.offsetHeight - this.element.clientHeight
            this.element.style.height = 'auto'
            this.element.style.height = `${this.element.scrollHeight + offset}px`
        }

        if (this.notNullable === false && typeof this.internalValue === 'string' && this.internalValue.length === 0) {
            this.internalValue = null
        }

        const value = this.transformOutput(this.internalValue)
        if (!isEqual(this.value, value)) {
            this.$emit('input', value)
        }
    }

    onInput(): void {
        this.$emit('input', this.internalValue)
    }

    onFocus(): void {
        this.focus = true
    }

    onBlur(): void {
        this.focus = false
    }

    get inputListeners() {
        return Object.assign({}, this.$listeners, {
            input: this.onInput,
            focus: this.onFocus,
            blur: this.onBlur,
        })
    }

    get inputAttrs() {
        return Object.assign({}, this.$attrs)
    }

    get componentClass(): object {
        return {
            'input-textarea': true,
            'input-textarea--focussed': this.focus,
            'input-textarea--disabled': this.disabled,
            'bd-round-outline': true,
        }
    }
}
